import { createContext, ReactNode, useEffect, useState } from 'react';
import { useAuth } from './auth';
import { ModalTermConditions } from '../components/Modals/ModalTermConditions';
import { useApp } from './app';
import { UserController } from '../controller/UserController';
import { useAlert } from '../hooks/useAlert';

type ProviderProps = {
  children: ReactNode;
};

type ContextProps = {};

export const UserRoleContext = createContext({} as ContextProps);

export function UserRoleProvider({ children }: ProviderProps) {
  const app = useApp();
  const alert = useAlert();
  const { user, tokenIsValid, provider, setUser } = useAuth();
  const [isOpenTermConditions, setIsOpenTermConditions] = useState(false);

  const handleAcceptTermConditions = async () => {
    setIsOpenTermConditions(false);
    app.setLoading(true);
    await UserController.confirmUserRole()
      .then(() => {
        setUser({
          ...user,
          acceptedPrivacyPolicy: true,
          acceptedTermConditions: true,
        });
        alert.show({ message: 'Perfil confirmado com sucesso', type: 'success' });
        setIsOpenTermConditions(false);
      })
      .catch(() => {
        alert.show({ message: 'Erro ao confirmar perfil, tente novamente', type: 'error' });
      })
      .finally(() => {
        app.setLoading(false);
      });
  };

  useEffect(() => {
    if ((!user.acceptedPrivacyPolicy || !user.acceptedTermConditions) && tokenIsValid && provider) {
      setIsOpenTermConditions(true);
    }
  }, [provider, tokenIsValid, user]);

  return (
    <UserRoleContext.Provider value={{}}>
      {children}
      <ModalTermConditions
        isOpen={isOpenTermConditions}
        onCallBack={() => handleAcceptTermConditions()}
      />
    </UserRoleContext.Provider>
  );
}
